module.exports = __webpack_public_path__ + "static/media/APP_MotherTeresa_152x174_5.50ff6f2b.png";